//Library Imports
import React, { ReactNode, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import store, { RootState } from "store";
import styled from "styled-components";

//Local Imports
import Digest from "../../../../assets/img/icons/Digest-email.svg";
import Email from "../../../../assets/img/icons/Hoc-email.svg";
import FloatingSidebarTwo from "modules/Common/Components/FloatingSidebarTwo";
import FooterActionButton from "./FooterActionButton";
import Input from "../../../Common/Components/Input";
import CustomSelectAsset from "../../../Design/Assets/CustomSelectAsset";
import CreateAssetAsider from "./CreateAssetAsider";
import TemplateFloatingSidebar from "modules/Common/Components/TemplateFloatingSidebar";
import NewCampaignModule from "./NewCampaignModule";
import Message from "modules/Common/Components/Message";
import ConfirmDialog from "modules/Common/Components/ConfirmDialog";
import { Menu, Dropdown } from "antd";
import { ICampaignsName } from "../../interfaces";
import {
  ASSET_DETAILS,
  CAMPAIGNS_LIST,
  EDITION_NAME_CHANGE,
  EMAIL_LIST,
  GET_CAMPAIGNS_NAMES_ONLY,
  ASSET_LIST,
} from "constants/types";
import {
  getCampaignsNamesOnly,
  resetCampaigns,
  searchLists,
  searchPeople,
  resetIncludedKeywords,
  resetCampaignsNamesOnly,
} from "../actions";
import { ASSET_TYPE } from "../../../../constants/index";
import { createNewCampaignSerialize, resetAllData } from "modules/Campaigns/utils";
import {
  createAssetAndCampaignService,
  createEmailService,
  updateAssetAndCampaignService,
} from "modules/Services/CampaignsService";
import { closeOverlay, dynamicBody, GLOBAL_ACTION, openOverlay } from "modules/GlobalActions";
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
import {
  ALL_ARTICLES_IN_EDITION,
  EMAIL_BROWSER,
  EMAIL_BROWSER_ADD_EMAIL,
  EMAIL_BROWSER_EMAILS_IN_CAMPAIGN,
} from "constants/actionTypes";
import {
  addCampaignAgainstEmailInEmailBrowser,
  removeEmailFromEmailBrowserList,
  removeEmailWithoutCampaign,
} from "modules/EmailBrowser/actions";
import { createAssetAction, createCampaign, updateAssetAction } from "modules/Campaigns/Emails/actions";
import { getEditionArticles } from "modules/Campaigns/Edition/actions";
import { getQueryParam } from "../../../../utils";

type Props = {
  children?: ReactNode;
  className?: string;
  wrapperclass?: string;
  noPortal?: boolean;
  updateAsset?: boolean;
  name?: string;
  assetId?: string;
  campaignId?: any;
  noDropdown?: boolean;
  redirectRoute?: string;
  noRedirection?: boolean;
  fromPublish?: boolean;
  redirectURL?: string;
  callbackMethod?: (value: any) => void;
  fromPublishCallBack?: () => void;
  dropDownWidth?: string;
  hideDynamic?: boolean;
  updateURL?: boolean;
  saveonPublish?: boolean;
  actionDivClass?: string;
  onClickAfter?: any;
  handleVisibleChange?: any; // for handling visiblity of popup menu
  placementCreateAssetPopup?: string;
  cloneDraftEmailToCampaign?: boolean;
  emailName?: string;
  draftEmailId?: number;
  hide?: () => void;
  saveAsAsset?: boolean;
  handleSaveAsEmail?: (value1: string, value2: string, value3: number, value4: any, value5: any) => void;
  disableSaveAs?: (value: boolean) => void;
};

const CreateAsset: React.FC<Props> = ({
  children,
  className,
  wrapperclass,
  updateAsset = false,
  campaignId,
  name,
  assetId,
  noDropdown,
  redirectRoute,
  noRedirection,
  fromPublish,
  redirectURL,
  dropDownWidth,
  callbackMethod,
  fromPublishCallBack,
  hideDynamic,
  updateURL,
  saveonPublish,
  actionDivClass,
  onClickAfter,
  handleVisibleChange,
  placementCreateAssetPopup,
  cloneDraftEmailToCampaign,
  emailName,
  draftEmailId,
  handleSaveAsEmail,
  saveAsAsset,
  hide,
  disableSaveAs,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  // states for toggling asiders
  const [assetType, setAssetType] = useState("");
  const [showAssetAsider, setShowAssetAsider] = useState(false);
  const [showCampaignAsider, setShowCampaignAsider] = useState(false);
  const [showCreateAdHocAsset, setCreateAdHocAsset] = useState(false);
  const [showTemplateAsider, setShowTemplateAsider] = useState(false);
  const [showAudienceAsider, setShowAudienceAsider] = useState(false);
  const [showOverWriteMessage, setShowOverWriteMessage] = useState(false);

  const isOverlay = useSelector((state: RootState) => state.uiReducer.overlay);
  // states for asset creation
  const [selectedCampaign, setSelectedCampaign] = useState(campaignId ? campaignId : 0);
  const [toggleDisable, setToggleDisabled] = useState("disabled");
  const [assetName, setAssetName] = useState(name || "");
  const [toggleAssetNameEdit, setToggleAssetNameEdit] = useState("editable-active");
  const campaignItems = useSelector((state: RootState) => state.getCampaignNames.data);
  const campaignItemsLoading = useSelector((state: RootState) => state.getCampaignNames.loading);
  const campaignSearchTerm = useSelector((state: RootState) => state.getCampaignNames.searchTerm);

  // states for campaign creation
  const [toggleCampaignSaveDisable, setToggleCampaignSaveDisable] = useState("disabled");
  const [campaignName, setCampaignName] = useState("");
  const [campaignKeywords, setCampaignKeywords] = useState(Array<string>());
  const [selectedContactIds, setSelectedContactIds] = useState(Array<number>());
  const [selectedListIds, setSelectedListIds] = useState(Array<number>());
  const [selectedContactNames, setSelectedContactNames] = useState(Array<string>());
  const [selectedListNames, setSelectedListNames] = useState(Array<string>());

  //states for template flow
  const [selectedTemplateId, setSelectedTemplateId] = useState(0);
  const [selectedTemplateName, setSelectedTemplateName] = useState("");
  const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
  const emailData = useSelector((state: RootState) => state.editionData);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const DEFAULT_PAGE_LIMIT = 20;

  useEffect(() => {
    if (showSuccessMessage) {
      setTimeout(() => {
        setShowSuccessMessage(false);
        handleCancel();
      }, 3000);
    }
  }, [showSuccessMessage]);

  function handleCreateUpdateAsset() {
    if (updateAsset && !showCampaignAsider) {
      handleUpdateEmail();
    } else if (showCampaignAsider) {
      if (updateAsset) {
        handleUpdateEmailAndCampaign();
      } else {
        handleCreateEmailAndCampaign();
      }
    } else {
      handleCreateEmail();
    }
  }

  const cloneDraftEmailToCampaignHandler = () => {
    if (showCampaignAsider) {
      draftEmailId &&
        assetName &&
        createEmailService(
          assetName,
          undefined,
          undefined,
          draftEmailId?.toString(),
          1,
          1,
          campaignName,
          campaignKeywords,
          selectedContactIds,
          selectedListIds
        )
          .then(({ data }) => {
            if (data.success) setShowSuccessMessage(true);
            // const obj = {
            //   name: data?.campaign_data?.campaign_name,
            //   campaign_id: data.campaign_id,
            //   thumbnails: data.thumbnails,
            //   emails_count: 1,
            //   last_update: "just now",
            //   total_contacts: "0",
            //   total_sent: "0",
            //   total_delivered: "0",
            //   total_open: "0",
            //   total_clicks: "0",
            // };
            // store.dispatch({
            //   type: CAMPAIGNS_LIST.APPEND_CAMPAIGN_AT_START,
            //   payload: obj,
            // });
            const currentCampaignId = getQueryCampaignId();
            if (currentCampaignId !== data.campaign_id) {
              const serializedCampaign = createNewCampaignSerialize(data.campaign_data, 1);
              dispatch({
                type: CAMPAIGNS_LIST.ADD_NEW,
                payload: serializedCampaign,
              });
              dispatch({
                type: GET_CAMPAIGNS_NAMES_ONLY.SUCCESS,
                payload: [
                  {
                    campaign_id: data.campaign_id,
                    name: data?.campaign_data?.campaign_name,
                  },
                ],
                newlyAdded: true,
              });
            }
          })
          .catch((err) => { });
    } else {
      const currentCampaignId = getQueryCampaignId();
      assetName &&
        createEmailService(assetName, selectedCampaign, undefined, draftEmailId?.toString(), 1)
          .then((res) => {
            const data = res.data;
            if (data.success) {
              if (selectedCampaign === currentCampaignId)
                store.dispatch({
                  type: EMAIL_LIST.CLONE_DRAFT_SUCCESS,
                  payload: { draftEmailId, data },
                });
              store.dispatch({
                type: CAMPAIGNS_LIST.UPDATE_ASSET_COUNT,
                campaign_id: selectedCampaign,
                add: true,
              });
            }
            handleCancel();
            // hide();

            // const data = res.data;
            // // resetAllData();
            // store.dispatch({
            //   type: EMAIL_LIST.RESET,
            //   payload: true,
            // });
            // if (currentCampaignId.toString() === selectedCampaign.toString()) {
            //   store.dispatch({
            //     type: EMAIL_LIST.CLONE_DRAFT_SUCCESS,
            //     payload: { draftEmailId, data },
            //   });
            //   handleCancel();
            // } else {
            //   if (data.success) {
            //     setShowSuccessMessage(true);
            //   }
            // }
          })
          .catch((err) => { });
    }
  };

  function handleUpdateEmail() {
    if (assetId) {
      setToggleDisabled("disabled");
      const asset_name = (assetName || name) ?? "";
      const emailId = getQueryEmailId() !== 0 ? getQueryEmailId()?.toString() : assetId;
      const campaign_id = selectedCampaign.toString();
      updateAssetAction(asset_name, emailId.toString(), campaign_id).then((response: any) => {
        if (response.data.success === true) {
          closeOverlay();
          resetCampaigns();
          removeEmailWithoutCampaign(parseInt(emailId));
          if (campaign_id)
            addCampaignAgainstEmailInEmailBrowser(
              parseInt(emailId),
              parseInt(campaign_id),
              response.data.campaign_data.campaign_name
            );
          if (fromPublish && fromPublishCallBack) {
            fromPublishCallBack();
          }
          if (!noRedirection) {
            if (redirectRoute) {
              history.push(`/campaigns/content/${redirectRoute}?campaign_id=${campaign_id}&email_id=${emailId}`);
            }
            if (redirectURL) {
              history.push(redirectURL + "&campaign_id=" + campaign_id);
            } else {
              history.push(`/campaigns/editionedit/source/?campaign_id=${campaign_id}&email_id=${emailId}`);
            }
          } else {
            setShowAssetAsider(false);
            setToggleDisabled("");
            if (updateURL) {
              history.push({ search: window.location.search + "&campaign_id=" + campaign_id });
            }
          }
          if (callbackMethod) {
            callbackMethod(false);
          }
        } else {
          console.error("Error occurred while creating asset.", response);
          setToggleDisabled("");
        }
      });
    } else {
      console.log("No Asset Id Found!");
    }
  }

  function handleCreateEmail() {
    // call create asset API and redirect to smart sources content
    setToggleDisabled("disabled");
    const asset_name = assetName;
    const campaign_id = selectedCampaign.toString();
    createAssetAction(asset_name, campaign_id)
      .then((response) => {
        if (response.data.success === true) {
          resetAllData();
          getEditionArticles(response.data?.email_id);

          store.dispatch({
            type: EMAIL_LIST.RESET,
            payload: true,
          });
          dispatch({
            type: CAMPAIGNS_LIST.UPDATE_ASSET_COUNT,
            campaign_id: campaign_id,
            add: true,
          });

          setAssetName("");
          if (!noRedirection) {
            if (redirectURL) {
              history.push(`${redirectURL}?${window.location.search}`);
            } else if (redirectRoute) {
              let campaignId = getQueryParam("campaign_id");
              // checking if user added email in another campaign then reset the state.
              if (campaignId !== campaign_id) {
                dispatch(resetIncludedKeywords());
                store.dispatch({
                  type: ASSET_LIST.RESET_ADVANCED_SEARCH,
                });
              }
              if (window.location.pathname.includes("source")) {
                let jsonData = response.data;
                store.dispatch({
                  type: EMAIL_BROWSER_ADD_EMAIL.ADD_SUCCESS,
                  payload: {
                    email: {
                      emailId: jsonData["email_id"],
                      name: jsonData["name"],
                      subject: jsonData["name"],
                      articlesCount: jsonData["article_count"],
                      campaignId: jsonData["campaign_id"],
                      campaignName: emailData.digestName,
                      thumbnails: jsonData["thumbnails"],
                      // lastUpdate: jsonData["last_updated"],
                      lastUpdate: "just now",
                      createdOn: jsonData["created_on"],
                      type: 0,
                    },
                    campaignId,
                    onlyCampaign: true,
                    isIncludeInEmailsDashboard: true,
                  },
                });
              }
              history.push(
                `/campaigns/editionedit/${redirectRoute}?campaign_id=${campaign_id}&email_id=${response.data?.email_id}`
              );
            } else {
              history.push(
                "/campaigns/editionedit/source/?campaign_id=" +
                campaign_id +
                "&email_id=" +
                response.data?.email_id
              );
            }
          } else {
            handleCancel();
          }
        } else {
          console.error("Error occurred while creating asset.: ", response);
          setToggleDisabled("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handleCreateEmailAndCampaign() {
    // call create asset API and redirect to smart sources content
    setToggleDisabled("disabled");
    const asset_name = assetName;
    const campaign_name = campaignName;
    const keywords = campaignKeywords;
    const contactIds = selectedContactIds;
    const listIds = selectedListIds;
    createAssetAndCampaignService(asset_name, campaign_name, keywords, contactIds, listIds)
      .then((response) => {
        if (response.data.success === true) {
          closeOverlay();
          resetAllData();
          getEditionArticles(response.data?.email_id);
          store.dispatch({
            type: EMAIL_LIST.RESET,
            payload: true,
          });
          store.dispatch({
            type: GLOBAL_ACTION.CLOSE_CREATE_ASSET_SIDEBAR,
          });
          store.dispatch({
            type: GLOBAL_ACTION.EMAIL_CREATED_CHECK,
            payload: true,
          });
          store.dispatch({
            type: EMAIL_LIST.CAMPAIGN_KEYWORDS_WHEN_CREATING_NEW_EMAIL,
            payload: keywords,
          });
          store.dispatch({
            type: EMAIL_BROWSER.RESET_EDITIONS_IN_ASSET,
          });

          const serializedCampaign = createNewCampaignSerialize(response.data.campaign_data, 1);
          dispatch({
            type: CAMPAIGNS_LIST.ADD_NEW,
            payload: serializedCampaign,
          });
          dispatch({
            type: GET_CAMPAIGNS_NAMES_ONLY.SUCCESS,
            payload: [
              {
                campaign_id: response.data.campaign_data.campaign_id,
                name: response.data.campaign_data.campaign_name,
              },
            ],
            newlyAdded: true,
          });
          if (!noRedirection) {
            if (!redirectRoute && showCampaignAsider) {
              history.push(
                `/campaigns/editionedit/source/?campaign_id=${response?.data?.campaign_id}&email_id=${response?.data?.email_id}`
              );
              return;
            }
            if (redirectRoute) {
              history.push(
                `/campaigns/editionedit/${redirectRoute}?campaign_id=${response?.data?.campaign_id}&email_id=${response?.data?.email_id}`
              );
              return;
            }
            if (redirectURL) {
              history.push(redirectURL + "&campaign_id=" + response?.data?.campaign_id);
              return;
            } else {
              history.push(
                "/campaigns/editionedit?campaign_id=" +
                response.data.campaign_id +
                "&email_id=" +
                response.data.email_id
              );
              return;
            }
          } else if (updateURL) {
            history.push({ search: window.location.search + "&campaign_id=" + response.data.campaign_id });
            return;
          }
        } else {
          console.error("Error occurred while creating email. ", response);
          setToggleDisabled("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handleUpdateEmailAndCampaign() {
    // call create asset API and redirect to smart sources content
    setToggleDisabled("disabled");
    if (assetId || getQueryEmailId()) {
      const asset_name = assetName !== "" ? assetName : name || "";
      const asset_id = getQueryEmailId() !== 0 ? getQueryEmailId()?.toString() : assetId || "";
      const campaign_name = campaignName;
      const keywords = campaignKeywords;
      const contactIds = selectedContactIds;
      const listIds = selectedListIds;
      updateAssetAndCampaignService(asset_id, asset_name, campaign_name, keywords, contactIds, listIds)
        .then((response) => {
          if (response.data.success === true) {
            closeOverlay();
            setShowAssetAsider(false);
            resetAllData();
            store.dispatch({
              type: GLOBAL_ACTION.CLOSE_CREATE_ASSET_SIDEBAR,
            });
            store.dispatch({
              type: EDITION_NAME_CHANGE.ASSET_NAME_UPDATE,
              payload: asset_name,
            });
            const campaign_data = response.data.campaign_data;
            const serializedCampaign = createNewCampaignSerialize(campaign_data, 1);
            dispatch({
              type: CAMPAIGNS_LIST.ADD_NEW,
              payload: serializedCampaign,
            });
            store.dispatch({
              type: GET_CAMPAIGNS_NAMES_ONLY.SUCCESS,
              payload: [
                {
                  campaign_id: response.data.campaign_data.campaign_id,
                  name: response.data.campaign_data.campaign_name,
                },
              ],
              newlyAdded: true,
            });

            getEditionArticles(asset_id);
            removeEmailWithoutCampaign(parseInt(asset_id));

            const campaign_id = response.data?.campaign_data?.campaign_id;
            if (fromPublish && fromPublishCallBack) {
              fromPublishCallBack();
            }
            if (saveonPublish)
              history.push({
                search: `?campaign_id=${campaign_id}&email_id=${getQueryEmailId()}`,
              });
            if (!noRedirection) {
              if (redirectRoute) {
                history.push(
                  `/campaigns/content/${redirectRoute}?campaign_id=${campaign_id}&email_id=${asset_id}`
                );
              }
              if (redirectURL) {
                history.push(redirectURL + "&campaign_id=" + campaign_id);
              } else {
                history.push("/campaigns/content/source?campaign_id=" + campaign_id + "&email_id=" + asset_id);
              }
            } else if (updateURL) {
              history.push({ search: window.location.search + "&campaign_id=" + campaign_id });
            }
            if (callbackMethod) {
              callbackMethod(false);
            }
          } else {
            console.error("Error occurred while creating asset. ", response);
            setToggleDisabled("");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  function setCampaignItems(newCampaignItems: ICampaignsName[]) {
    // when new campaign is created, this will add the new campaign in the
    // campaigns dropdown while creating new asset
    store.dispatch({
      type: GET_CAMPAIGNS_NAMES_ONLY.UPDATE,
      payload: newCampaignItems,
    });
  }

  function onClickCreateCampaign(e: any) {
    setShowCampaignAsider(true);
    // if (!campaignId)
    setSelectedCampaign(0);
    setToggleDisabled("disabled");
    // setShowTemplateAsider(false);
    setSelectedListIds([]);
    setSelectedListNames([]);
    setSelectedContactIds([]);
    setSelectedContactNames([]);
  }

  function handleCancel(fromSaveAs?: boolean, cid?: number, cname?: string, clicked?: boolean) {
    if (fromSaveAs && cid !== undefined && cname !== undefined && selectedCampaign === 0) {
      const serializedCampaign = createNewCampaignSerialize({ campaign_name: cname, campaign_id: cid }, 1);
      // setCampaignItems([serializedCampaign, ...campaignItems]);
      // const serializedCampaign = createNewCampaignSerialize(campaign_data, 1);
      dispatch({
        type: CAMPAIGNS_LIST.ADD_NEW,
        payload: serializedCampaign,
      });
      store.dispatch({
        type: GET_CAMPAIGNS_NAMES_ONLY.SUCCESS,
        payload: [
          {
            campaign_id: cid,
            name: cname,
          },
        ],
        newlyAdded: true,
      });
    }

    if (!clicked) {
      if (disableSaveAs)
        setTimeout(() => {
          disableSaveAs(false);
        }, 2000);
    }
    // if triggered from Campaign dot menu, it will remove the top-20000 class from popup
    hide && hide();
    if (handleVisibleChange) handleVisibleChange(false);
    if (showSuccessMessage) setShowSuccessMessage(false);
    setCampaignName("");
    setSelectedCampaign(getQueryCampaignId() !== undefined ? getQueryCampaignId() : 0);
    setShowCampaignAsider(false);
    setShowAssetAsider(false);
    setShowTemplateAsider(false);
    setAssetType("");
    setAssetName("");
    setCampaignKeywords([]);
    setSelectedContactIds([]);
    setSelectedContactNames([]);
    setSelectedListIds([]);
    setSelectedListNames([]);
    setSelectedContactIds([]);
    setToggleDisabled("");
    if (!campaignId) setSelectedCampaign(0);
    document.body.style.overflow = "auto";
    document.body.style.height = "100%";
    closeOverlay();
    if (campaignSearchTerm) resetCampaignsNamesOnly();
  }

  function handleClickCancel() {
    handleCancel(undefined, undefined, undefined, true);
  }

  function handleCancelTemplateAsider() {
    // if triggered from Campaign dot menu, it will remove the top-20000 class from popup
    if (handleVisibleChange) handleVisibleChange(false);
    setCreateAdHocAsset(false);
    setShowTemplateAsider(false);
    setShowCampaignAsider(false);
    setShowAudienceAsider(false);
    setAssetName("");
    setShowCampaignAsider(false);
    setCampaignKeywords([]);
    setSelectedContactIds([]);
    setSelectedListIds([]);
    if (!campaignId) setSelectedCampaign(0);
    setSelectedTemplateId(0);
    setSelectedTemplateName("");
    setSelectedTemplateImage("");
    closeOverlay();
    setSelectedCampaign(getQueryCampaignId() !== undefined ? getQueryCampaignId() : 0);
    document.body.style.overflow = "auto";
    document.body.style.height = "100%";
  }
  function handleCancelCreateCampaign() {
    // hide test keyword and people asider
    setShowAudienceAsider(false);
    // hide campaign asider
    setShowCampaignAsider(false);
    setCampaignName("");
  }

  function handleOnRemoveCampaignKeyword(searchTermId: string, isExtended: boolean) {
    // upon click on cross icon, remove the keyword from the list
    const updatedCampaignKeywords = [...campaignKeywords];
    const index = updatedCampaignKeywords.indexOf(searchTermId);
    if (index >= 0) {
      updatedCampaignKeywords.splice(index, 1);
      setCampaignKeywords(updatedCampaignKeywords);
    }
    searchPeople(updatedCampaignKeywords.toString(), true);
    searchLists(updatedCampaignKeywords.toString(), true);
  }

  function handleAddPeople(id: number, name: string, audience_type: string, email?: string) {
    // add audience to the campaign from Recommended People section
    if (audience_type === "contact") {
      if (name === "" && email !== undefined) {
        name = email;
      }
      if (selectedContactIds.indexOf(id) < 0) {
        setSelectedContactIds([...selectedContactIds, id]);
        setSelectedContactNames([...selectedContactNames, name]);
      } else {
        handleRemovePeople(id, name, audience_type);
      }
    } else if (audience_type === "list") {
      if (selectedListIds.indexOf(id) < 0) {
        setSelectedListIds([...selectedListIds, id]);
        setSelectedListNames([...selectedListNames, name]);
      } else {
        handleRemovePeople(id, name, audience_type);
      }
    }
  }

  function handleRemovePeople(id: number, name: string, audience_type: string) {
    // remove audience to the campaign from Recommended People section
    if (audience_type === "contact") {
      const updatedContactIds = [...selectedContactIds];
      const updatedContactNames = [...selectedContactNames];
      let index = updatedContactIds.indexOf(id);
      if (index >= 0) {
        updatedContactIds.splice(index, 1);
        updatedContactNames.splice(index, 1);
        setSelectedContactIds(updatedContactIds);
        setSelectedContactNames(updatedContactNames);
      }
    } else if (audience_type === "list") {
      const updatedListIds = [...selectedListIds];
      const updatedListNames = [...selectedListNames];
      let index = updatedListIds.indexOf(id);
      if (index >= 0) {
        updatedListIds.splice(index, 1);
        updatedListNames.splice(index, 1);
        setSelectedListIds(updatedListIds);
        setSelectedListNames(updatedListNames);
      }
    }
  }

  // handle asset name input
  const handleNameInput = (e: any) => {
    if (showCampaignAsider) {
      if (toggleDisable === "disabled" && e.target.value.trim().length > 0 && campaignName.trim().length > 0) {
        setToggleDisabled("");
      } else if (e.target.value.trim().length === 0) {
        setToggleDisabled("disabled");
      }
    } else if (showCreateAdHocAsset) {
      if (
        toggleDisable === "disabled" &&
        e.target.value.trim().length > 0 &&
        campaignName.length > 0 &&
        selectedTemplateId !== 0
      ) {
        setToggleDisabled("");
      } else if (e.target.value.trim().length === 0) {
        setToggleDisabled("disabled");
      }
    } else {
      if (toggleDisable === "disabled" && e.target.value.trim().length > 0 && selectedCampaign !== 0) {
        setToggleDisabled("");
      } else if (e.target.value.trim().length === 0) {
        setToggleDisabled("disabled");
      }
    }
    if (e.target.value.trim() === "") {
      setToggleDisabled("disabled");
    }
    setAssetName(e.target.value);
  };

  const handleCampaignName = (e: any) => {
    if (showCreateAdHocAsset) {
      if (
        toggleDisable === "disabled" &&
        e.target.value.trim().length > 0 &&
        assetName.trim().length > 0 &&
        selectedTemplateId !== 0
      ) {
        setToggleDisabled("");
      } else if (e.target.value.trim().length === 0) {
        setToggleDisabled("disabled");
      }
    } else {
      if (
        toggleDisable === "disabled" &&
        e.target.value.trim().length > 0 &&
        (assetName.trim().length > 0 || name?.trim() !== "")
      ) {
        setToggleDisabled("");
      } else if (e.target.value.trim().length === 0) {
        setToggleDisabled("disabled");
      }
    }
    if (assetName.trim() === "") {
      setToggleDisabled("disabled");
    }
    setCampaignName(e.target.value);
  };

  function handleCreateNewCampaign() {
    // create new campaign and update the campaigns dropdown in
    // create asset asider
    setToggleCampaignSaveDisable("disabled");
    createCampaign(campaignName, campaignKeywords, selectedContactIds, selectedListIds)
      .then((res: any) => {
        if (res.data.success === true) {
          resetAllData();
          setShowAudienceAsider(false);
          setShowCampaignAsider(false);
          setCampaignName("");
          setCampaignKeywords([]);
          setSelectedContactIds([]);
          setSelectedListIds([]);
          setCampaignItems([
            ...campaignItems,
            { campaign_id: res.data.campaign_id, name: res.data.campaign_name },
          ]);
          setSelectedCampaign(res.data.campaign_id);
          if (assetName.trim().length > 0) setToggleDisabled("");

          const serializedCampaign = createNewCampaignSerialize(res.data);
          dispatch({
            type: CAMPAIGNS_LIST.ADD_NEW,
            payload: serializedCampaign,
          });
          history.push(`/campaigns/content/source?campaign_id=${campaignId}`);
        } else {
          console.error("Error occurred in create campaign API.: ", res);
        }
      })
      .catch((err: any) => {
        console.error("Error occurred in create campaign API.: ", err);
      });
  }

  function handleOnClickBrowsePeople() {
    // hide test keyword and people asider
    setShowAudienceAsider(true);
    setShowTemplateAsider(false);
  }

  function onClickAudienceDone() {
    // close recommended audience section
    setShowAudienceAsider(false);
  }

  function handleSelectedCampaign(value: any) {
    if (value !== 0 && (assetName.trim() !== "" || (name?.trim() !== "" && name?.trim() !== undefined))) {
      if (assetType === ASSET_TYPE.HYBRID || window.location.pathname.includes("editionedit")) {
        setToggleDisabled("");
      } else {
        handleAdhocNameInput(value, "campaign");
      }
    }
    if (assetName.trim() === "") {
      setToggleDisabled("disabled");
    }
    setSelectedCampaign(value);
    setShowCampaignAsider(false);
  }

  function checkExistingVersion() {
    if (getQueryCampaignId() === parseInt(selectedCampaign) && name?.trim() === assetName?.trim()) {
      setShowOverWriteMessage(true);
      return;
    } else {
      setShowOverWriteMessage(false);
      overWriteAsset();
    }
  }
  function overWriteCancel() {
    setShowOverWriteMessage(false);
  }

  function overWriteAsset() {
    const asset_name = assetName ?? name;
    const campaign_name = campaignName;
    const campaign_id = selectedCampaign.toString();
    setShowOverWriteMessage(false);
    setToggleDisabled("disabled");
    if (handleSaveAsEmail)
      handleSaveAsEmail(
        asset_name,
        campaign_name,
        campaign_name === "" ? campaign_id : 0,
        handleCancel,
        setShowOverWriteMessage
      );
    resetCampaignsNamesOnly();
  }

  function getSearchedPagination(reset?: boolean) {
    let offset = reset ? 0 : campaignItems ? campaignItems.length : 0;
    let limit = DEFAULT_PAGE_LIMIT;
    let object: any = { offset, limit };
    if (campaignSearchTerm && !reset) object.search_campaign = campaignSearchTerm;
    return { ...object };
  }

  function handleSaveAsEmailAsider() {
    if (onClickAfter) onClickAfter();
    if (parseInt(campaignId) > 0) setSelectedCampaign(campaignId);
    if (!hideDynamic) dynamicBody();
    openOverlay();
    if (campaignItems.length <= 10 && !campaignItemsLoading) {
      getCampaignsNamesOnly(getSearchedPagination());
    }
    setShowAssetAsider(true);
    setShowAudienceAsider(false);
    if (saveAsAsset) setToggleDisabled("");
  }

  function handleAsiderOpen() {
    if (saveAsAsset) {
      handleSaveAsEmailAsider();
      return;
    }
    if (onClickAfter) onClickAfter();
    if (parseInt(campaignId) > 0) setSelectedCampaign(campaignId);
    if (!hideDynamic) dynamicBody();
    openOverlay();
    if (campaignItems.length <= 10 && !campaignItemsLoading) {
      getCampaignsNamesOnly(getSearchedPagination());
    }
    setShowAssetAsider(true);
    setAssetType("hybrid");
    setShowAudienceAsider(false);
    if (saveAsAsset) setToggleDisabled("");
  }

  function handleAdHocAsider() {
    if (onClickAfter) onClickAfter();
    if (parseInt(campaignId) > 0) setSelectedCampaign(campaignId);
    if (!hideDynamic) dynamicBody();
    openOverlay();
    if (campaignItems.length <= 10 && !campaignItemsLoading) {
      getCampaignsNamesOnly(getSearchedPagination());
    }
    setShowAssetAsider(false);
    setAssetType("custom");
    setCreateAdHocAsset(true);
    setToggleDisabled("disabled");
    setShowAudienceAsider(false);
  }

  function showTemplatesBrowser() {
    setShowTemplateAsider(!showTemplateAsider);
    setShowAudienceAsider(false);
  }

  function loadMoreCampaigns(reset?: boolean) {
    if (!campaignItemsLoading) getCampaignsNamesOnly(getSearchedPagination(reset));
  }

  function handleSearchCampaign(value: string) {
    resetCampaignsNamesOnly();
    if (value.trim() !== "") {
      if (!campaignItemsLoading)
        getCampaignsNamesOnly({ offset: 0, limit: DEFAULT_PAGE_LIMIT, search_campaign: value });
    } else {
      getCampaignsNamesOnly({ offset: 0, limit: DEFAULT_PAGE_LIMIT });
    }
  }

  const handleAdhocNameInput = (e: any, type: string) => {
    if (e === undefined) {
      return;
    }
    if (type === "id") {
      setSelectedTemplateId(e);
    }
    if (type === "name") {
      setAssetName(e.target.value);
    }
    if (type === "campaign") {
      setSelectedCampaign(e);
    }
    if (
      toggleDisable === "disabled" &&
      (assetName.trim().length > 0 || (type === "name" && e.target.value.trim().length > 0)) &&
      (selectedCampaign !== 0 || campaignName.trim().length > 0 || (type === "campaign" && e > 0)) &&
      (selectedTemplateId > 0 || (type === "id" && e > 0))
    ) {
      setToggleDisabled("");
    } else if (type === "name" && e.target.value.trim().length === 0) {
      setToggleDisabled("disabled");
    }
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = "auto";
      // setShowAssetAsider(false);
    };
  }, []);

  const menu = (
    <Menu className={`asset-dropdown ${className === undefined ? "" : className}`}>
      <h5 className="heading">Create a new email</h5>
      <Menu.Item className="mr" onClick={() => handleAdHocAsider()}>
        <div className="list-item">
          <img src={Email} alt="hoc-email" />
          <span className="head">Ad hoc Email</span>
          <p className="dec">Design, craft send ad hoc emails that can be anything you need them to be.</p>
        </div>
      </Menu.Item>
      <Menu.Item className="mr" onClick={() => handleAsiderOpen()}>
        <div className="list-item">
          <img src={Digest} alt="digest-email" />
          <span className="head">Digest Email</span>
          <p className="dec">Add, remove or change keywords here to adjust your content feed.</p>
        </div>
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    if (name && assetName !== name) {
      setAssetName(name);
    }
    if (emailName) {
      setAssetName(emailName);
    }
  }, [name, showAssetAsider, emailName]);

  useEffect(() => {
    if (showAssetAsider && !isOverlay) {
      setShowAssetAsider(false);
    }
  }, [isOverlay]);

  return (
    <>
      <Wrapper className={`${className === undefined ? "" : className}`}>
        {noDropdown ? (
          <div {...(actionDivClass ? { className: actionDivClass } : {})} onClick={() => handleAsiderOpen()}>
            {children}
          </div>
        ) : (
          <Dropdown
            overlayClassName={`Popover-share ${wrapperclass}`}
            overlay={menu}
            placement={`${placementCreateAssetPopup ? "bottomCenter" : "bottomRight"}`}
            arrow
            trigger={["click"]}
            getPopupContainer={() => document.querySelectorAll(".content-inner")[0] as HTMLElement}
          >
            <span
              className={`ant-dropdown-link ${dropDownWidth ? dropDownWidth : ""}`}
              onClick={(e) => e.preventDefault()}
            >
              {children}
            </span>
          </Dropdown>
        )}
        {ASSET_TYPE.HYBRID && (
          <FloatingSidebarTwo
            isToggle={showAssetAsider && isOverlay}
            className="new-asset-wrapper"
            CampaignAsider={true}
            handleCancelCreateCampaign={handleCancelCreateCampaign}
            keywordAsider={true}
            isToggleAsider={showAudienceAsider}
            handleOnClickBrowsePeople={handleOnClickBrowsePeople}
            onClickAudienceDone={onClickAudienceDone}
            handleOnRemoveCampaignKeyword={handleOnRemoveCampaignKeyword}
            campaignKeywords={campaignKeywords}
            setCampaignKeywords={setCampaignKeywords}
            handleAddPeople={handleAddPeople}
            campaignName={campaignName}
            setCampaignName={setCampaignName}
            handleCreateNewCampaign={handleCreateNewCampaign}
            toggleCampaignSaveDisable={toggleCampaignSaveDisable}
            setToggleCampaignSaveDisable={setToggleCampaignSaveDisable}
            assetFlow={true}
            selectedContactIds={selectedContactIds}
            selectedContactNames={selectedContactNames}
            selectedListIds={selectedListIds}
            selectedListNames={selectedListNames}
          >
            <div className={`create-campaign-wrapper ${showCampaignAsider ? "overflowed" : ""}`}>
              <h1 className="create-campaign-heading">
                {cloneDraftEmailToCampaign ? (
                  <>
                    Save to
                    <br />
                    Campaign
                  </>
                ) : (
                  <>
                    {updateAsset ? "Edit" : saveAsAsset ? "Save As" : "Create New"}
                    <br />
                    Email
                  </>
                )}
              </h1>
              {showSuccessMessage && (
                <div style={{ marginTop: 15 }}>
                  <Message label="Success" message="Email saved successfully" />
                </div>
              )}
              <div className={`edit-wrapper ${toggleAssetNameEdit}`}>
                {/* Toggle editable-active class */}
                <span className="name-span" style={{ width: "100%" }}>
                  <Input
                    type="text"
                    label={cloneDraftEmailToCampaign ? "Email Name" : "Name your new email"}
                    placeholder="Give your email a name"
                    onChange={handleNameInput}
                    value={assetName ?? name}
                    idInput="email-name-input-digest"
                  />
                </span>
              </div>

              <Wrap>
                <h5 className="heading-dropdown mb-1">
                  {cloneDraftEmailToCampaign ? "Campaign Name" : "Save email to a campaign"}
                </h5>
                <CustomSelectAsset
                  campaigns_list={campaignItems}
                  campaignName={"Please select..."}
                  selectedValue={
                    showCampaignAsider
                      ? "Create new campaign"
                      : campaignItems?.find(
                        (item) => selectedCampaign?.toString() === item?.campaign_id?.toString()
                      )?.name
                  }
                  loadingCampaigns={campaignItemsLoading}
                  handleSearchCampaign={handleSearchCampaign}
                  loadMore={loadMoreCampaigns}
                  // setCampaignName={(value: string) => {
                  //   "user";
                  // }}
                  assetId={assetId ?? draftEmailId}
                  setSelectedCampaign={handleSelectedCampaign}
                  onClickCreateCampaign={(value: any) => {
                    onClickCreateCampaign(value);
                  }}
                  isCampaignDropDown={true}
                />
              </Wrap>
              {showCampaignAsider ? (
                <div className={showCampaignAsider ? "new-campaign-bottom" : "d-none"}>
                  <NewCampaignModule
                    handleCampaignNameInput={handleCampaignName}
                    handleOnClickBrowsePeople={handleOnClickBrowsePeople}
                    onClickAudienceDone={onClickAudienceDone}
                    selectedContactIds={selectedContactIds}
                    selectedContactNames={selectedContactNames}
                    selectedListIds={selectedListIds}
                    selectedListNames={selectedListNames}
                    handleAddPeople={handleAddPeople}
                    handleOnRemoveCampaignKeyword={handleOnRemoveCampaignKeyword}
                    campaignKeywords={campaignKeywords}
                    setCampaignKeywords={setCampaignKeywords}
                    setCampaignName={setCampaignName}
                    assetType={assetType}
                    saveAsAsset={saveAsAsset !== undefined ? saveAsAsset : false}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
            <FooterActionButton>
              <span className="footer-btn mr" onClick={handleClickCancel} id="cancel-email-asset">
                Cancel
              </span>
              <span
                className={`footer-btn filled-success ${toggleDisable}`}
                onClick={
                  cloneDraftEmailToCampaign
                    ? cloneDraftEmailToCampaignHandler
                    : saveAsAsset
                      ? checkExistingVersion
                      : handleCreateUpdateAsset
                }
                id="save-btn-asset"
              >
                Save
              </span>
            </FooterActionButton>
          </FloatingSidebarTwo>
        )}
        {ASSET_TYPE.CUSTOM && (
          <TemplateFloatingSidebar
            isToggle={showCreateAdHocAsset}
            showTemplateAsider={showTemplateAsider}
            setShowTemplateAsider={setShowTemplateAsider}
            adhocAsider={true}
            handleCancelCreateCampaign={handleCancelCreateCampaign}
            handleOnClickBrowsePeople={handleOnClickBrowsePeople}
            setToggleCampaignSaveDisable={setToggleCampaignSaveDisable}
            handleOnRemoveCampaignKeyword={handleOnRemoveCampaignKeyword}
            handleSelectedCampaign={handleSelectedCampaign}
            onClickCreateCampaign={onClickCreateCampaign}
            selectedCampaign={parseInt(selectedCampaign) <= 0 ? campaignId : selectedCampaign}
            campaignItems={campaignItems}
            audienceAsider={showAudienceAsider}
            toggleCampaignSaveDisable={toggleCampaignSaveDisable}
            handleCreateNewCampaign={handleCreateNewCampaign}
            setCampaignName={setCampaignName}
            setCampaignKeywords={setCampaignKeywords}
            campaignKeywords={campaignKeywords}
            handleAddPeople={handleAddPeople}
            handleCancelTemplateAsider={handleCancelTemplateAsider}
            campaignName={campaignName}
            rightMargin="0px"
            topMargin="0px"
            fitContent={false}
            className="template-panel"
            onClickAudienceDone={onClickAudienceDone}
            setSelectedTemplateId={setSelectedTemplateId}
            setSelectedTemplateName={setSelectedTemplateName}
            setSelectedTemplateImage={setSelectedTemplateImage}
            selectedTemplateId={selectedTemplateId}
            selectedTemplateName={selectedTemplateName}
            handleAdhocNameInput={handleAdhocNameInput}
            selectedContactIds={selectedContactIds}
            selectedListIds={selectedListIds}
            setToggleDisabled={setToggleDisabled}
          >
            <CreateAssetAsider
              setCreateAdHocAsset={setCreateAdHocAsset}
              handleOnRemoveCampaignKeyword={handleOnRemoveCampaignKeyword}
              setCampaignKeywords={setCampaignKeywords}
              setSelectedContactIds={setSelectedContactIds}
              setSelectedContactNames={setSelectedContactNames}
              selectedContactIds={selectedContactIds}
              selectedContactNames={selectedContactNames}
              setSelectedListIds={setSelectedListIds}
              setSelectedListNames={setSelectedListNames}
              selectedListIds={selectedListIds}
              selectedListNames={selectedListNames}
              handleAddPeople={handleAddPeople}
              onClickAudienceDone={onClickAudienceDone}
              templateAsider={showTemplateAsider}
              campaignItems={campaignItems}
              selectedCampaign={parseInt(selectedCampaign) <= 0 ? campaignId : selectedCampaign}
              showCampaignAsider={showCampaignAsider}
              handleSelectedCampaign={handleSelectedCampaign}
              onClickCreateCampaign={onClickCreateCampaign}
              onClickCancel={handleCancelTemplateAsider}
              showTemplatesBrowser={showTemplatesBrowser}
              selectedTemplateName={selectedTemplateName}
              selectedTemplateImage={selectedTemplateImage}
              setAssetName={setAssetName}
              toggleAssetNameEdit={toggleAssetNameEdit}
              assetName={assetName}
              toggleDisable={toggleDisable}
              campaignName={campaignName}
              setToggleDisabled={setToggleDisabled}
              selectedTemplateId={selectedTemplateId}
              handleAdhocNameInput={handleAdhocNameInput}
              handleCampaignName={handleCampaignName}
              handleOnClickBrowsePeople={handleOnClickBrowsePeople}
              assetType={assetType}
              loadingCampaigns={campaignItemsLoading}
              loadMore={loadMoreCampaigns}
              handleSearchCampaign={handleSearchCampaign}
            />
          </TemplateFloatingSidebar>
        )}
        {showOverWriteMessage && (
          <DialogWrapper>
            <div className="back-overlay" />
            <ConfirmDialog
              confirm="Ok"
              onConfirm={overWriteCancel}
              title={`The email name "${assetName}" is already taken. Try another name for this copy.`}
              titleQuestion={null}
              noellipsis="noellipsis" // changed this prop to lowercase as the browser was consoling an error with the camel case naming convention
            />
          </DialogWrapper>
        )}
      </Wrapper>
    </>
  );
};

export default React.memo(CreateAsset);

const DialogWrapper = styled.div`
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
  .back-overlay {
    position: fixed;
    background: grey;
    opacity: 0.2;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
  }
`;

const TextSpan = styled.span`
  vertical-align: middle;
  margin-right: 0.5em;
  color: #717171;
  font-weight: 700;
  font-size: 16px;
  font-family: "robotoregular";
`;

const Wrap = styled.div`
  .scheduling-dropdown {
    > {
      div {
        width: 100% !important;
      }
    }
  }
  .heading-dropdown {
    font-family: "Roboto", sans-serif;
    font-weight: 600;
    color: #5e7079;
    font-size: 18px;
    margin-top: 50px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-top: 30px;
      font-size: 12px;
    }
  }
`;

const SchedulingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .heading {
    font-family: "Roboto Slab", serif;
    font-weight: 600;
    color: #5e7079;
    font-size: 18px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  &.hide-mac-article {
    .search-terms-wrap .add-words-wrapper {
      display: none;
    }
  }
  &.add-btn-dropdown {
    height: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  /* .ant-dropdown-link {
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      min-width: 190px;
    }
  } */
  .overflowed {
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #efefef;
    }
  }
  .new-campaign-bottom {
    margin-bottom: 20px;
  }
  .create-campaign-wrapper {
    padding: 47px 40px 0px 40px;
    position: relative;
    height: calc(100% - 72px);
    margin-bottom: 72px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 30px 20px 0px 20px;
    }
    /* min-height: 754px;
    max-height: calc(100vh - 210px); */
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox*/
    ::-webkit-scrollbar {
      display: none;
    }
    .create-campaign-heading {
      color: #424b50;
      font-size: 46px;
      font-weight: 800;
      line-height: 48px;
      margin-bottom: 0px;
      display: block;
      font-family: "Roboto Slab", serif;
      /* width: 250px; */
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 32px;
        line-height: 40px;
      }
    }
    .edit-wrapper {
      display: flex;
      margin-top: 30px;
      margin-bottom: 30px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 20px;
        margin-bottom: 30px;
      }
      .new-campaign {
        color: #9b9b9b;
        font-size: 22px;
        line-height: 47px;
        margin-bottom: 0px;
        display: inline-block;
        font-family: "Roboto Slab", serif;
      }
      .edit-icon {
        margin-left: 10px;
        cursor: pointer;
      }
      .name {
        width: 100%;
        input {
          width: 100%;
        }
      }
      &.editable-active {
        .editable {
          display: block;
        }
      }
    }
  }

  .name-span {
    color: rgb(155, 155, 155);
    position: relative;
    float: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    div {
      width: 100%;
    }
    .tooltip {
      position: relative;
      display: inline-block;
      opacity: 1;
      z-index: 0;
      .tooltiptext {
        color: #ffffff;
        font-size: 11px;
        letter-spacing: 0.02px;
        line-height: 15px;
        text-align: center;
        background-color: #263153;
        visibility: hidden;
        border-radius: 4px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        transform: translateX(-50%);
        opacity: 0;
        transition: opacity 0.3s;
        padding: 5px 10px;
        &:after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #263153 transparent transparent transparent;
        }
      }
      &:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
      }
    }
    .asset-name {
      text-overflow: ellipsis;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      float: left;
      max-width: 700px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-width: 445px;
      }
    }
    &.editable-active {
      .editable {
        display: block;
        min-width: 320px;
      }
    }
    .editable {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      display: none;
      label {
        display: none;
      }
      input {
        padding-right: 70px;
      }
      .save {
        position: absolute;
        top: 9px;
        right: 10px;
        height: 100%;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 20px;
        }
      }
      .cancel {
        position: absolute;
        top: 9px;
        right: 40px;
        height: 100%;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 20px;
          padding: 2px;
        }
      }
    }
    .edit-btn {
      cursor: pointer;
      margin-left: 10px;
    }
  }
`;
